"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var FullView = /** @class */ (function (_super) {
    __extends(FullView, _super);
    function FullView(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            style: {
                height: props.vertical ? "100vh" : "unset",
                width: props.horizontal ? "100vw" : "unset"
            }
        };
        return _this;
    }
    FullView.prototype.render = function () {
        return (React.createElement("div", { style: this.state.style }, this.props.children));
    };
    return FullView;
}(React.Component));
exports.FullView = FullView;
//# sourceMappingURL=FullView.js.map